import React from 'react';

import { CheckCircleOutline, GroupOutlined, HowToRegOutlined } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { useStateExhibitTemplateQuery } from '@uplift/queries';

import { PracticeStateRow } from './PracticeStatesTable.types';

export type StateNameCellProps = {
  value?: string;
  row: PracticeStateRow;
};

const IndependentPracticeIcon: React.FC<{ providerId: string; licenseId: string }> = ({ providerId, licenseId }) => {
  const { data: exhibitTemplate } = useStateExhibitTemplateQuery(providerId, licenseId);

  if (!exhibitTemplate) {
    return null;
  }

  return (
    <Tooltip title="Independent practice available">
      <HowToRegOutlined fontSize="small" color="success" />
    </Tooltip>
  );
};

export const StateNameCell: React.FC<StateNameCellProps> = ({ value, row }) => {
  const hasRequirement = row.requiresCollaborativeAgreement || row.allowsStateExhibit;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, width: 48, flexShrink: 0 }}>
        {row.requiresCollaborativeAgreement && (
          <Tooltip title="Collaboration agreement required">
            <GroupOutlined fontSize="small" color="action" />
          </Tooltip>
        )}
        {row.allowsStateExhibit && (
          <React.Suspense fallback={null}>
            <IndependentPracticeIcon providerId={row.providerId} licenseId={row.licenseId} />
          </React.Suspense>
        )}
        {!hasRequirement && (
          <Tooltip title="Ready - No requirements">
            <CheckCircleOutline fontSize="small" color="success" />
          </Tooltip>
        )}
      </Box>
      {value}
    </Box>
  );
};
